import { QuantityEntity } from "../../generalSettings/unit/units"
import { Config } from "../config/config";
import { ComponentHelper } from "../util/componentHelper";
import { Helper } from "../util/helper";
import { HTTPService, JsonResultClass } from "../util/httpManager"
import { IsSearchField } from "./isSearchField"
import { Dialog, DialogProps } from "./dialog"
import { DropDownList } from "./dropDownList";
import { Field, FieldInstance } from "./field";
import { Button, ButtonProps } from "./button"
import { FAIcon, FAIconProps } from "./faIcon";
import { BaseComponentProps, BaseField } from "./baseComponentProps";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class UnitSearchBox extends React.Component<UnitSearchBoxProps, UnitSearchBoxState> {

    private factory = ComponentHelper.createFactory();
    private dataSource: DataSourceItem[];
    private translations: StringKeyDictionary<string>;

    constructor(props: UnitSearchBoxProps) {
        super(props)
        this.state = {
            value: props.value,
            dialogOpen: false
        }
        this.initApp();
    }

    private setValue = (value: string, dataItem: any = null) => {
        this.setState({ value: value }, () => {
            this.props.onChange(this.props.field, value, dataItem)
        })
    }

    private initApp = async () => {
        $(window).on("unitsChanged", async (e) => {
            this.dataSource = await this.loadPossibleData();
            this.setState({})
        });
        const result = await Promise.all([
            this.loadPossibleData(),
            this.loadTranslations()
        ]);
        this.dataSource = result[0];
        this.translations = result[1];
        if (Helper.hasValue(this.props.onDataLoaded))
            this.props.onDataLoaded(this.dataSource)
        this.setState({})
    }

    private getURL = () => {
        let url = "Unit/Find";
        if (!Helper.isNullOrEmpty(this.state.value)) {
            url += "?id=" + this.state.value;
        }
        if (!Helper.isNullOrEmpty(this.props.field.identifier)) {
            url += `${url.includes("?") ? "&" : "?"}identifier=${this.props.field.identifier}`
        }
        return url;
    }

    private loadPossibleData = async () => {
        let url = this.getURL();
        return await HTTPService.get<DataSourceItem[]>(url);
    }

    private loadTranslations = async () => {
        const key = "unit_search_translations";
        let translations: StringKeyDictionary<string> = Helper.loadDataFromStorage(key);
        if (Helper.hasValue(translations)) {
            return translations;
        } else {
            const result = await Helper.getTranslations([
                "Field.Barauslage.Unit",
                "WebSMS.GeneralSettings.Units.UnitIsDeleted",
                "WebSMS.GeneralSettings.Units.Quantity"
            ]);
            if (result.Code == 0) {
                Helper.saveDataToStorage(key, result.Data, false);
                return result.Data;
            }
        }
    }

    private createSearchBox = () => {
        let props = this.factory.getDefaultSearchFieldProps();
        props.field.searchButtonEnabled = false;
        if (Helper.hasValue(this.state.value)) {
            const item = this.dataSource.find(x => x.Id == this.state.value);
            if (Helper.hasValue(item))
                props.value = item.Name;
        }
        props.field.autocompleteEnabled = true;
        props.context = {
            contextType: "unit-search-box"
        }
        props.field.autocompleteUrl = this.getURL();
        props.field.autocompleteDataTextField = "Name";
        props.field.autocompleteTemplate = "<table cellspacing='0' style='table-layout:fixed; width:350px'><colgroup><col style='width: 150px' /><col style='width: 75px' /><col style='width: 125px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top; word-wrap: break-word;'>${data.Name}</td><td style='vertical-align:top'>${data.Chars}</td><td style='vertical-align:top'>${data.Quantity}</td></tr></table>"
        props.onChange = (_, val, dataItem: DataSourceItem) => {
            let value = null;
            if (Helper.hasValue(dataItem) && !Helper.isNullOrEmpty(val)) {
                value = dataItem.Id
            }
            this.setValue(value, dataItem);
        }
        props.disabled = this.props.disabled;

        return <IsSearchField {...props}/>
    }

    private createDialog = () => {
        const isOk = (id: string) => {
            if (!Helper.isNullOrEmpty(id)) {
                const dataItem = this.dataSource.find(f => f.Id == id);
                this.setValue(id, dataItem);
            }
        }
        return (
            <>
                <UnitSearchDialog
                    translations={this.translations}
                    isOpen={this.state.dialogOpen}
                    onClose={() => { this.setState({ dialogOpen: false }) }}
                    onOk={isOk}
                    identifier={this.props.field.identifier}
                    unitId={this.state.value}
                />
            </>
        );
    }

    private createButton = () => {
        const props: ButtonProps = {
            iconName: "search",
            handleClick: () => {
                this.setState({ dialogOpen: true })
            },
            buttonStyle: {
                height: "38px",
                borderColor: "#ced4da",
                borderRadius: "var(--rounded-right)",
                borderLeft: "none",
                width: "28px",
                backgroundColor: "#e4e7eb"
            }
        }
        return (
            <Button {...props} />
        );
    }

    private createIcon = () => {
        const props: FAIconProps = {
            name: "exclamation-triangle",
            style: {
                color: "#e64a19"
            },
            attributes: ["lg"]
        }
        const title = this.translations["WebSMS.GeneralSettings.Units.UnitIsDeleted"]
        return (
            <div style={{ margin: "0 3px" }} title={title}>
                <FAIcon {...props}/>
            </div>
        );
    }

    render() {
        const item = Helper.hasValue(this.dataSource) && !Helper.isNullOrEmpty(this.state.value) ? this.dataSource.find(f => f.Id == this.state.value) : null;

        const searchBox = Helper.hasValue(this.dataSource) ? this.createSearchBox() : null;
        const button = this.props.disabled ? null : this.createButton();
        const dialog = !this.props.disabled && Helper.hasValue(this.translations) ? this.createDialog() : null;
        const icon = Helper.hasValue(item) && item.IsDeleted ? this.createIcon() : null;
        return (
            <>
                <div className="unit-search-box">
                    {icon}
                    {button}
                    <div style={{ flexGrow: 100 }}>
                        {searchBox}
                    </div>
                </div>
                {dialog}
            </>
        );
    }
}

export interface UnitSearchBoxProps extends BaseComponentProps{
    value: string;
    field: UnitSearchBoxField;
    onChange?(field, value: string, dataItem?: any);
    onDataLoaded?(dataSource: any);
}

interface UnitSearchBoxField extends BaseField {
    identifier: string;
}

interface UnitSearchBoxState {
    value: string;
    dialogOpen: boolean;
}

interface DataSourceItem {
    Id: string;
    Name: string;
    Chars: string;
    Quantity: string;
    IsDeleted: boolean;
}

class UnitSearchDialog extends React.Component<UnitSearchDialogProps, UnitSearchDialogState>{

    private dataSource: QuantityEntity[];
    private factory = ComponentHelper.createFactory();

    private dialogProps: DialogProps = {
        title: Config.translations.search,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.setState({
                        quantityId: this.props.identifier,
                        unitId: this.props.unitId
                    })

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOk(this.state.unitId)
                    this.setState({ })
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onClose()
        },
        width: 500
    };

    constructor(props: UnitSearchDialogProps) {
        super(props)
        this.initApp();
        this.state = {
            quantityId: "",
            unitId: props.unitId ?? ""
        }
    }

    private initApp = async () => {
        this.dataSource = await this.loadQuantities();
        let quantityId = "";
        if (this.dataSource.length == 1) {
            quantityId = this.dataSource[0].Id;
        }
        this.setState({ quantityId: quantityId });
    }

    private loadQuantities = async () => {
        let url = "Unit/GetAllQuantities";
        if (!Helper.isNullOrEmpty(this.props.identifier)) {
            url += `?identifier=${this.props.identifier}`
        }
        const result = await HTTPService.noBusyIndicator().get<JsonResultClass<QuantityEntity[]>>(url);
        if (result.Code == 0) {
            return result.Data;
        } else {
            console.error(result.Message);
            return [];
        }
    }

    private createDialog = () => {
        return (
            <Dialog {...this.dialogProps} open={true}>
                {this.createQuantityDropDown()}
                {Helper.isNullOrEmpty(this.state.quantityId) ? null : this.createUnitDropDown()}
            </Dialog>
        );
    }

    private createQuantityDropDown = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.field.dataTextField = "DisplayName";
        props.field.dataValueField = "Id";
        props.value = this.state.quantityId;
        props.dataSource = this.dataSource;
        props.onChange = (_, value) => {
            this.setState({ quantityId: value, unitId: "" })
        }
        return (
            <FieldInstance label={this.props.translations["WebSMS.GeneralSettings.Units.Quantity"]} noHover={true}>
                <DropDownList {...props}/>
            </FieldInstance>
        );
    }

    private createUnitDropDown = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.field.dataTextField = "DisplayName";
        props.field.dataValueField = "Id";
        props.field.refreshDSOnRefChange = true;
        props.value = this.state.unitId;
        props.dataSource = this.dataSource.find(f => f.Id == this.state.quantityId).Units;
        props.onChange = (_, value) => {
            this.setState({ unitId: value })
        }
        return (
            <FieldInstance label={this.props.translations["Field.Barauslage.Unit"]} noHover={true}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    render() {
        const dialog = Helper.hasValue(this.dataSource) && this.props.isOpen ? this.createDialog() : null;
        return <>{dialog}</>;
    }
}

interface UnitSearchDialogProps {
    unitId: string;
    translations: StringKeyDictionary<string>;
    isOpen: boolean;
    identifier?: string;
    onOk: (id: string) => void;
    onClose: () => void;
}

interface UnitSearchDialogState {
    quantityId: string;
    unitId: string;
}